module.exports = __webpack_public_path__ + "static/img/steel-plate_256.e18b2ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/steel-plate_256.png
// module id = LrRY
// module chunks = 0